import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
export function useAnalytics() {
  const location = useLocation()

  useEffect(() => {
    // Only track if user has accepted analytics cookies
    const consent = localStorage.getItem('cookie-consent')
    if (consent !== 'accepted') return

    if (!window.gtag) return

    // Track page view in GA4
    window.gtag('event', 'page_view', {
      page_path: location.pathname + location.search,
      page_location: window.location.href,
      page_title: document.title,
    })

    // Also push to dataLayer for GTM
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'page_view',
        page_path: location.pathname + location.search,
        page_location: window.location.href,
        page_title: document.title,
      })
    }
  }, [location])
}
